import { useEffect, useState } from "react";
import { getAuthData } from "../../../utils/AuthUtil";
import { is_empty } from "../../Common/utils/common.utils";
import { getLocalStorageItem } from "../../Common/modules/Storage/modules/LocalStorage/utils/LocalStorage.utils";
import { LOCAL_STORAGE_KEYS } from "../../Common/modules/Storage/modules/LocalStorage/constants/LocalStorage.constants";

export const useSupportWidget = () => {
  const [shouldShowSupportWidget, setShouldShowSupportWidget] = useState(false);

  useEffect(() => {
    const checkSupportWidgetConditions = () => {
      const auth = getAuthData();

      // Check if user is logged in
      if (is_empty(auth?.email) || is_empty(auth?.sub_domain)) {
        return false;
      }

      // Check if user is staff
      const is_staff = !is_empty(
        getLocalStorageItem(LOCAL_STORAGE_KEYS.BD_EMAIL)
      );
      if (is_staff) {
        return false;
      }

      // Check if support widget is enabled
      const isSupportWidgetEnabled =
        !is_empty(process.env.REACT_APP_SUPPORT_WIDGET_ENABLED) &&
        process.env.REACT_APP_SUPPORT_WIDGET_ENABLED === "true";

      if (!isSupportWidgetEnabled) {
        return false;
      }

      return true;
    };

    setShouldShowSupportWidget(checkSupportWidgetConditions());
  }, []);

  return {
    shouldShowSupportWidget,
  };
};
